var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integralUser" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [
        _vm._v(
          "自提人信息（" +
            _vm._s(_vm.identityType === 1 ? "企业" : "个人") +
            "）"
        )
      ]),
      _c("div", { staticClass: "box30" }),
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "flex items-center justify-end" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.updatePickUp("")
                    }
                  }
                },
                [_vm._v("添加自提人")]
              )
            ],
            1
          ),
          _c("div", { staticClass: "box30" }),
          _c(
            "el-table",
            {
              attrs: { border: "", data: _vm.list, "row-class-name": "pointer" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "name",
                  label: "自提人姓名",
                  "min-width": "20%"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "tel",
                  label: "手机号",
                  "min-width": "15%"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "red mar20-r",
                            on: {
                              click: function($event) {
                                return _vm.updatePickUp(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "red",
                            on: {
                              click: function($event) {
                                return _vm.delPickUp(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center mar40-t" },
            [
              _c("div", { staticClass: "gray9 flex-auto" }, [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.pageTotal) +
                    " 条记录 第 " +
                    _vm._s(_vm.pageNum) +
                    " / " +
                    _vm._s(_vm.totalPage) +
                    " 页"
                )
              ]),
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next, sizes, jumper",
                  background: "",
                  "hide-on-single-page": "",
                  "page-size": _vm.pageSize,
                  "page-count": _vm.totalPage,
                  "current-page": _vm.pageNum,
                  "page-sizes": [30, 50, 100]
                },
                on: {
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.addVisible,
            width: "500px",
            center: "",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "自提人", prop: "name" } },
                [
                  _vm.ruleForm.id
                    ? _c("span", [_vm._v(_vm._s(_vm.ruleForm.name))])
                    : _c("el-input", {
                        attrs: {
                          maxlength: "10",
                          placeholder: "请输入自提人姓名"
                        },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.name"
                        }
                      })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "tel" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "11",
                      placeholder: "请输入自提人手机号"
                    },
                    model: {
                      value: _vm.ruleForm.tel,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "tel",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.tel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "text-right mar0-b" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.resetForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }